import { __decorate, __metadata } from "tslib";
import { IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
export class SearchTaxResultDto {
}
__decorate([
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchTaxResultDto.prototype, "guid", void 0);
__decorate([
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], SearchTaxResultDto.prototype, "name", void 0);
__decorate([
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], SearchTaxResultDto.prototype, "percentage", void 0);
__decorate([
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], SearchTaxResultDto.prototype, "isDefault", void 0);
__decorate([
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], SearchTaxResultDto.prototype, "isIncluded", void 0);
//# sourceMappingURL=SearchTaxResultDto.js.map